import { styled } from '@linaria/react';

export const BetOddButtonWrapper = styled.div`
  & button {
    color: var(--cxy-color-midnight-blue-600);
  }
`;
